import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  x_newsletter: {
    id: 'x_newsletter',
    defaultMessage: 'Click here to subscribe to our newsletter',
  },
  x_newsletter_sign_up: {
    id: 'x_newsletter_sign_up',
    defaultMessage: 'Sign up',
  },
  back_to_top: {
    id: 'back_to_top',
    defaultMessage: 'Back to top',
  },
  why_with_us: {
    id: 'why_with_us',
    defaultMessage: 'Why with us',
  },
  solutions_products: {
    id: 'solutions_products',
    defaultMessage: 'Solutions & Products',
  },
  references: {
    id: 'references',
    defaultMessage: 'References',
  },
  about_us: {
    id: 'about_us',
    defaultMessage: 'About us',
  },
  research: {
    id: 'research',
    defaultMessage: 'Research',
  },
  blog: {
    id: 'blog',
    defaultMessage: 'Blog',
  },
  career_with_us: {
    id: 'career_with_us',
    defaultMessage: 'Join our team',
  },
  free_jobs: {
    id: 'free_jobs',
    defaultMessage: 'Available jobs',
  },
  team: {
    id: 'team',
    defaultMessage: 'Team',
  },
  up_to_date: {
    id: 'up_to_date',
    defaultMessage: 'Stay up to date',
  },
  find_us: {
    id: 'find_us',
    defaultMessage: 'Find us here',
  },
  imprint: {
    id: 'imprint',
    defaultMessage: 'Imprint',
  },
  data_privacy: {
    id: 'data_privacy',
    defaultMessage: 'Data privacy',
  },
  contact: {
    id: 'contact',
    defaultMessage: 'Contact',
  },
  remote_maintenance: {
    id: 'remote_maintenance',
    defaultMessage: 'Remote maintenance',
  },
  mailto_subject: {
    id: 'mailto_subject',
    defaultMessage: 'Subscribe%20Newsletter',
  },
  mailto_body: {
    id: 'mailto_body',
    defaultMessage:
      'Hello,%20I%20would%20like%20to%20subscribe%20to%20your%20newsletter%20using%20this%20email%20address.%20Thank%20you!',
  },
  more: {
    id: 'more',
    defaultMessage: 'More on this',
  },
  selected_categories: {
    id: 'selected_categories',
    defaultMessage: 'Selected categories',
  },
  phone: {
    id: 'phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
});
